import { ROUTES } from "@/app/router/routes";
import { clearTokens } from "@/services/token";

import { useLogoutApi } from "../api/use-auth-api";

export function useLogout() {
  const logoutApi = useLogoutApi();

  const logout = () => {
    logoutApi.mutate(undefined, {
      onSettled: () => {
        clearTokens();
        window.location.assign(`/${ROUTES.LOGIN}`);
      },
    });
  };

  return {
    logout,
    isPending: logoutApi.isPending,
  };
}
